(function($, undefined) {
	
	'use strict';
    // Create a Stripe client.
    var validateForm = function () {
        var stripe = ($("html").attr("data-is-dev") === 'true') ? Stripe('pk_test_HhX3YNMlO2VMhFdx6AFnBe3q') : Stripe($('#stripe-cc-form').attr('data-key'));
        var button = $('.get-stripe-token');
        var cardInputsCtn = button.closest('form').find('.card-inputs-inner');
        var cardErrorsId = "card-errors";
        var ccFieldsId = "#stripe-cc-form";
        var ccFields = $(ccFieldsId);
        var form = button.closest(".submit-after-validation-form");
        var style = JSON.parse($(ccFieldsId).data('style'));
        
        if (ccFields.length !== 0) {
            // Create an instance of Elements.
            var elements = stripe.elements();

            //// Create an instance of the card Element. Remove hidePostalCode if PC validation required
            var card = elements.create('card', {
                hidePostalCode: true, style});

            card.mount(ccFieldsId);

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function (event) {
                var displayError = document.getElementById(cardErrorsId);
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            var _checkout = function() {
                // In the checkout process the validation will go through recaptcha next so no submission after
                if (button.attr('data-widget-id') && !!window.grecaptcha) {
                    grecaptcha.execute(button.attr('data-widget-id'));
                } else {
                    if (button.closest('form').hasClass('checkout-form')) { 
                        var checkout = Fw.component.models().checkout;
                        checkout.continueCheckout(button);
                    } else {
                        var tools = Fw.component.models().tools;
                        tools.validateForm(button);
                        if(form.length !== 0) {
                            form.submit();
                        }
                    }
                }
            };

            // Handle form submission.
            button.on('click', function (event) {
                event.preventDefault();

                if ((cardInputsCtn.css('display') === 'block' && cardInputsCtn.css('visibility') === 'visible') 
                        || button.closest('.create-payment-form').length > 0) {
                    stripe.createToken(card).then(function (result) {
                        if (result.error) {
                            // Inform the user if there was an error.
                            var errorElement = document.getElementById(cardErrorsId);
                            errorElement.textContent = result.error.message;
                        } else {
                            // Send the token in a stripeToken param in the payment
                            var m;
                            if (result.token.card.exp_month < 10) {
                                m = '0' + result.token.card.exp_month;
                            } else {
                                m = result.token.card.exp_month;
                            }

                            $('input[name=cardToken]').val(result.token.id);
                            $('input[type=hidden].cc').val(result.token.card.last4);
                            $('input[type=hidden].mm').val(m);
                            $('input[type=hidden].yy').val(result.token.card.exp_year.toString().substring(2));

                            _checkout();
                        }
                    });
                } else {
                    _checkout();
                }
            });
        }
    };

	Fw.component.export('stripeToken', {
		init: validateForm
	});

})(jQuery);